(function webpackUniversalModuleDefinition(root, factory) {
	//CommonJS2 (nodejs)
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("canvas"));
	//AMD
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	//CommonJS
	else if(typeof exports === 'object')
		exports["JXG"] = factory(require("canvas"));
	//Root (browser)
	else
		root["JXG"] = factory(root["canvas"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE__841__) {
return 